/*
 * Reliance — Fenêtres « Le détail » du diagnostic visage (sections/rel-diagnostic-tableaux.liquid, E.2r3).
 *  - ouvre dialog[data-rel-tableau-dialog] depuis tout bouton [data-rel-tableau-open] de la page ;
 *  - matrice : portée data-scope (all | serums | actives) → colonnes du groupe, lignes sans point masquées,
 *    titre / intro / note de la portée ;
 *  - boutons d'ouverture rendus visibles seulement si leur fenêtre existe (sinon ils restent `hidden`) ;
 *  - fermeture : bouton, Échap (natif), clic hors de la boîte ; le focus revient au bouton d'origine (natif).
 *    Page figée pendant l'ouverture : en CSS (html:has(dialog[open])), sans dépendre de l'événement « close ».
 * Contrat data-* : en tête de la section.
 */
(function () {
  if (window.relTableauxInit) return;
  window.relTableauxInit = true;

  var GROUPS = { serums: ['serums'], actives: ['actives'] };

  function all(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function dialogFor(name) {
    return document.querySelector('dialog[data-rel-tableau-dialog="' + name + '"]');
  }

  function applyScope(dialog, scope) {
    var groups = GROUPS[scope] || null;
    if (!groups) scope = 'all';
    dialog.setAttribute('data-scope', scope);
    all(dialog, '[data-rel-tableau-scope]').forEach(function (el) {
      el.hidden = el.getAttribute('data-rel-tableau-scope') !== scope;
    });
    all(dialog, '[data-group]').forEach(function (cell) {
      cell.hidden = !!groups && groups.indexOf(cell.getAttribute('data-group')) === -1;
    });
    all(dialog, 'tr[data-rel-tableau-row]').forEach(function (row) {
      row.hidden = !!groups && !all(row, 'td:not([hidden]) [data-on]').length;
    });
    var box = dialog.querySelector('.rel-tab-dialog__scroll');
    if (box) box.scrollLeft = 0;
  }

  function open(button) {
    var dialog = dialogFor(button.getAttribute('data-rel-tableau-open'));
    if (!dialog || dialog.open) return;
    if (dialog.getAttribute('data-rel-tableau-dialog') === 'matrice') {
      applyScope(dialog, button.getAttribute('data-scope') || 'all');
    }
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  }

  function close(dialog) {
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  function revealOpeners() {
    all(document, '[data-rel-tableau-open]').forEach(function (button) {
      if (dialogFor(button.getAttribute('data-rel-tableau-open'))) button.hidden = false;
    });
  }

  function bindDialogs() {
    all(document, 'dialog[data-rel-tableau-dialog]').forEach(function (dialog) {
      if (dialog.relTableau) return;
      dialog.relTableau = true;
      dialog.addEventListener('click', function (event) {
        /* Clic sur le fond : la cible est le dialog lui-même (la boîte le recouvre entièrement sinon). */
        if (event.target === dialog || event.target.closest('[data-rel-tableau-close]')) close(dialog);
      });
    });
  }

  function boot() {
    bindDialogs();
    revealOpeners();
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-rel-tableau-open]');
    if (button) open(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
